import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  rtl:true,
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        gray:'#e8e8e8',
        lightGray:'rgba(255, 255, 255, 0.3)',
        primary: '#25458c',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#0846be',
        success: '#74B73B',
        warning: '#FCC300',
        black:'#000000',
        green:'#7BAD32',
      },
    },
  },
});
